import React from 'react';

import { Layout } from 'ds';

interface Props {
  progressPercent: number;
  delay?: number;
  animate?: boolean;
}

const OrderProgressBar: React.FC<Props> = ({ progressPercent, delay = 400, animate = true }) => {
  return (
    <Layout color="gray-50" borderRadius={8} align="center">
      <Layout
        color="blue-500"
        borderRadius={8}
        height={4}
        className={animate ? `animate-progress-bar-${progressPercent}` : ''}
        style={{ animationDelay: `${delay}ms` }}
      ></Layout>
      <Layout color="gray-50" width={`${100 - progressPercent}%`} height={4}></Layout>
    </Layout>
  );
};

export default OrderProgressBar;
